import * as React from "react";
import { Container } from "semantic-ui-react";
import NavBar from "../../containers/NavBar/NavBar";
import GlobalBluetoothStatus from "../../components/GlobalBluetoothStatus/GlobalBluetoothStatus";
import "./MainLayout.css";

interface MainLayoutProps {
    children?: React.ReactNode;
}

interface MainLayoutState {
    showSideNavBar: boolean;
}

class MainLayout extends React.Component<MainLayoutProps, MainLayoutState> {
    constructor(props: MainLayoutProps) {
        super(props);
        this.state = {
            showSideNavBar: false
        };
    }

    public closeSideNavBar = () => {
        this.setState({ showSideNavBar: false });
    }

    public render() {
        return (
            <React.Fragment>
                <NavBar />
                <GlobalBluetoothStatus />
                <Container className="main-layout-container" onClick={this.closeSideNavBar}>
                    {this.props.children}
                </Container>
            </React.Fragment>
        );
    }
}

export default MainLayout;
